import { Default } from './default';
import { US } from './US';
import { CA } from './CA';
import { AU } from './AU';
import { FR } from './FR';
import { NZ } from './NZ';
import { GB } from './GB';

export const countryFactory = (countryCode) => {
  switch (countryCode) {
    case 'AU':
      return AU;
    case 'CA':
      return CA;
    case 'FR':
      return FR;
    case 'NZ':
      return NZ;
    case 'GB':
      return GB;
    case 'US':
      return US;
    default:
      return Default;
  }
};
